<div class="price-container">
  <span class="price-label">{{'component.price.price' | translate}}:</span> <span class="primary-text-color fw-600 price">{{price | currency:'USD':'symbol'}}</span>
</div>
